module.exports = __webpack_public_path__ + "static/img/Scott.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/christmasPC-2019/Scott.png
// module id = aZoR
// module chunks = 1